var map = {
	"./0/Kambi/CrossActivity.resource.js": [
		32344,
		12217
	],
	"./0/Poker/CrossActivity.resource.js": [
		32805,
		41228
	],
	"./0/Spectate/CrossActivity.resource.js": [
		5477,
		228
	],
	"./1/Kambi/CrossActivity.resource.js": [
		58265,
		54296
	],
	"./1/Poker/CrossActivity.resource.js": [
		69712,
		2573
	],
	"./1/Spectate/CrossActivity.resource.js": [
		29674,
		35109
	],
	"./31/Kambi/CrossActivity.resource.js": [
		39664,
		30089
	],
	"./31/Poker/CrossActivity.resource.js": [
		2349,
		21126
	],
	"./31/Spectate/CrossActivity.resource.js": [
		70429,
		3918
	],
	"./58/Spectate/CrossActivity.resource.js": [
		90340,
		52241
	],
	"./75/Kambi/CrossActivity.resource.js": [
		82088,
		90545
	],
	"./75/Spectate/CrossActivity.resource.js": [
		35381,
		60606
	],
	"./76/Kambi/CrossActivity.resource.js": [
		21971,
		47070
	],
	"./76/Spectate/CrossActivity.resource.js": [
		15208,
		44337
	],
	"./8/Poker/CrossActivity.resource.js": [
		95565,
		50436
	],
	"./8/Spectate/CrossActivity.resource.js": [
		27389,
		14156
	],
	"./81/Kambi/CrossActivity.resource.js": [
		70609,
		43240
	],
	"./81/Spectate/CrossActivity.resource.js": [
		20770,
		57683
	],
	"./84/Kambi/CrossActivity.resource.js": [
		82508,
		37773
	],
	"./84/Spectate/CrossActivity.resource.js": [
		53849,
		64694
	],
	"./86/Spectate/CrossActivity.resource.js": [
		38375,
		2408
	],
	"./87/Spectate/CrossActivity.resource.js": [
		32956,
		8585
	],
	"./88/Spectate/CrossActivity.resource.js": [
		3397,
		47858
	],
	"./89/Spectate/CrossActivity.resource.js": [
		49130,
		93387
	],
	"./90/Spectate/CrossActivity.resource.js": [
		92544,
		26237
	],
	"./91/Spectate/CrossActivity.resource.js": [
		5643,
		94364
	],
	"./92/Spectate/CrossActivity.resource.js": [
		57714,
		9283
	],
	"./94/Spectate/CrossActivity.resource.js": [
		77324,
		15001
	],
	"./95/Spectate/CrossActivity.resource.js": [
		58711,
		98168
	],
	"./96/Poker/CrossActivity.resource.js": [
		67564,
		20999
	],
	"./96/Spectate/CrossActivity.resource.js": [
		60638,
		82527
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 71354;
module.exports = webpackAsyncContext;